<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post14-body-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post14-body-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.6734693877551;"
    data-aspect-ratio="0.673"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post14-body-xs-img"
      class="g-post14-body-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-body-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-shadowtext g-aiAbs"
      style="top:9.3878%;left:65.311%;width:31.2121%;"
    >
      <p class="g-pstyle1">
        The Iranian Red Crescent Society warned that this type of rain can cause <span
          class="g-cstyle0">chemical burns</span
        >
        to the skin and
        <span class="g-cstyle0">serious damage to the lungs.</span>
      </p>
    </div>
    <div
      id="g-ai0-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:18.69%;margin-top:-15.6px;left:2.5309%;width:103px;"
    >
      <p class="g-pstyle0">Toxic airborne</p>
      <p class="g-pstyle0">particles</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-shadowtext g-aiAbs"
      style="top:86.1224%;left:2.5309%;width:95.4545%;"
    >
      <p class="g-pstyle1">
        Inhaling acidic particles can irritate the airways, aggravate <span
          class="g-cstyle0">asthma and bronchitis</span
        >
        and allow fine particles to reach the bloodstream, where they can increase
        <span class="g-cstyle0">cardiovascular stress. </span>
      </p>
    </div>
    <div
      id="g-ai0-1"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:10.0165%;margin-top:-8.1px;left:39.028%;width:73px;"
    >
      <p class="g-pstyle0">Acid rain</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post14-body-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.09266054696507;"
    data-aspect-ratio="1.093"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post14-body-sm-img"
      class="g-post14-body-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-body-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-shadowtext g-aiAbs"
      style="top:12.2121%;left:73.5443%;width:25.8824%;"
    >
      <p class="g-pstyle1">
        The Iranian Red Crescent Society warned that this type of rain can cause <span
          class="g-cstyle0">chemical burns</span
        >
        to the skin and
        <span class="g-cstyle0">serious damage to the lungs.</span>
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:19.6388%;margin-top:-18.7px;left:1.7605%;width:115px;"
    >
      <p class="g-pstyle0">Toxic airborne</p>
      <p class="g-pstyle0">particles</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-shadowtext g-aiAbs"
      style="top:52.7048%;left:2.1477%;width:25.098%;"
    >
      <p class="g-pstyle1">
        Inhaling acidic particles can irritate the airways, aggravate <span
          class="g-cstyle0">asthma and bronchitis</span
        >
        and allow fine particles to reach the bloodstream, where they can increase
        <span class="g-cstyle0">cardiovascular stress. </span>
      </p>
    </div>
    <div
      id="g-ai1-1"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:10.2119%;margin-top:-9.7px;left:25.6742%;width:81px;"
    >
      <p class="g-pstyle0">Acid rain</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post14-body-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.375;"
    data-aspect-ratio="1.375"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post14-body-md-img"
      class="g-post14-body-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-body-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:18.4717%;margin-top:-18.7px;left:12.7643%;width:115px;"
    >
      <p class="g-pstyle0">Toxic airborne</p>
      <p class="g-pstyle0">particles</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-shadowtext g-aiAbs"
      style="top:20%;left:71.3833%;width:26.2121%;"
    >
      <p class="g-pstyle1">
        The Iranian Red Crescent Society warned that this type of rain can cause <span
          class="g-cstyle0">chemical burns</span
        >
        to the skin and
        <span class="g-cstyle0">serious damage to the lungs.</span>
      </p>
    </div>
    <div
      id="g-ai2-4"
      class="g-shadowtext g-aiAbs"
      style="top:49.1667%;left:1.4869%;width:28.0303%;"
    >
      <p class="g-pstyle1">
        Inhaling acidic particles can irritate the airways, aggravate <span
          class="g-cstyle0">asthma and bronchitis</span
        >
        and allow fine particles to reach the bloodstream, where they can increase
        <span class="g-cstyle0">cardiovascular stress. </span>
      </p>
    </div>
    <div
      id="g-ai2-1"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:9.0967%;margin-top:-9.7px;left:30.6445%;width:81px;"
    >
      <p class="g-pstyle0">Acid rain</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post14-body-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.5;"
    data-aspect-ratio="1.5"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post14-body-lg-img"
      class="g-post14-body-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-body-lg.jpg);"
    ></div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post14-body-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 2.22752964210123;"
    data-aspect-ratio="2.228"
    data-min-width="1200"
  >
    <div
      id="g-post14-body-xl-img"
      class="g-post14-body-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-body-xl.jpg);"
    ></div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-10 14:53 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-10 14:53 -->
<!-- ai file: post14-body.ai -->
<style lang="scss">
  #g-post14-body-box {
    container-type: inline-size;
    container-name: g-post14-body-box;
  }
  #g-post14-body-box,
  #g-post14-body-box .g-artboard {
    margin: 0 auto;
  }
  #g-post14-body-box p {
    margin: 0;
  }
  #g-post14-body-box .g-aiAbs {
    position: absolute;
  }
  #g-post14-body-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post14-body-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post14-body-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post14-body-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post14-body-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post14-body-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post14-body-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post14-body-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post14-body-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post14-body-xl {
        display: block !important;
      }
    }
  }
  #g-post14-body-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-body-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-body-xs .g-pstyle0 {
    font-weight: 400;
    height: 15px;
  }
  #g-post14-body-xs .g-pstyle1 {
    font-weight: 400;
  }
  #g-post14-body-xs .g-cstyle0 {
    font-weight: 700;
  }
  #g-post14-body-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-body-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-body-sm .g-pstyle0 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
  }
  #g-post14-body-sm .g-pstyle1 {
    font-weight: 400;
  }
  #g-post14-body-sm .g-cstyle0 {
    font-weight: 700;
  }
  #g-post14-body-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-body-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-body-md .g-pstyle0 {
    font-weight: 400;
    height: 18px;
  }
  #g-post14-body-md .g-pstyle1 {
    font-weight: 400;
  }
  #g-post14-body-md .g-cstyle0 {
    font-weight: 700;
  }
  #g-post14-body-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-body-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }

  /* Custom CSS */
  @mixin shadow-emmental($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      -1px 0 rgba($clr, $alpha),
      0 1px rgba($clr, $alpha),
      1px 0 rgba($clr, $alpha),
      0 -1px rgba($clr, $alpha);
  }
  .g-blackshadow {
    @include shadow-emmental(#000000);
  }
  .g-numbersc {
    background-color: #000000;
    border-radius: 50%;
    border: 1px solid #ffffff;
    aspect-ratio: 1;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
</style>
